// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"DataCollapseTable_wrapper__2lfxU","nameCell":"DataCollapseTable_nameCell__8Hpho"};